/*
  The ambassador wall (sections/ambassador-wall.liquid).

  Fetches the count and the opted-in first names, then shows one of three
  states: the invitation alone (nobody yet), a still row (a few names) or two
  drifting rows (many). The counter counts up once the wall scrolls into view.

  Any failure leaves the server-rendered invitation in place: a wall that
  breaks must read as "be the first", never as an error.
*/
(function () {
  'use strict';

  var MARQUEE_FROM = 6;
  // Enough names on one row to cover a wide screen before the loop repeats.
  var ROW_MIN = 12;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function nameNode(name, index) {
    var span = document.createElement('span');
    span.className = 'amb-wall__name';
    span.textContent = name;
    span.style.setProperty('--i', String(index));
    return span;
  }

  function fill(list) {
    var out = [];
    while (out.length < ROW_MIN) out = out.concat(list);
    return out;
  }

  function row(names, reverse) {
    var rowEl = document.createElement('div');
    rowEl.className = 'amb-wall__row' + (reverse ? ' amb-wall__row--reverse' : '');
    var track = document.createElement('div');
    track.className = 'amb-wall__track';
    // Slower for longer lists, so a name stays readable whatever the count.
    track.style.setProperty('--amb-wall-duration', Math.max(40, names.length * 4) + 's');
    var doubled = names.concat(names);
    doubled.forEach(function (name, i) {
      var node = nameNode(name, i);
      if (i >= names.length) node.setAttribute('aria-hidden', 'true');
      track.appendChild(node);
    });
    rowEl.appendChild(track);
    return rowEl;
  }

  function renderNames(container, names) {
    container.textContent = '';
    if (names.length >= MARQUEE_FROM && !reducedMotion()) {
      var half = Math.ceil(names.length / 2);
      container.appendChild(row(fill(names.slice(0, half)), false));
      container.appendChild(row(fill(names.slice(half).length ? names.slice(half) : names), true));
    } else {
      var still = document.createElement('div');
      still.className = 'amb-wall__still';
      names.forEach(function (name, i) { still.appendChild(nameNode(name, i)); });
      container.appendChild(still);
    }
    container.setAttribute('aria-label', names.join(', '));
    container.hidden = false;
  }

  function countUp(el, target, locale) {
    var format = function (n) {
      try { return new Intl.NumberFormat(locale).format(n); } catch (_) { return String(n); }
    };
    if (reducedMotion() || target <= 1) { el.textContent = format(target); return; }
    var start = null;
    var duration = 1400;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function whenVisible(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { threshold: 0.3 });
    io.observe(el);
  }

  function bind(section) {
    var url = section.getAttribute('data-amb-wall-url');
    if (!url) return;
    var locale = section.getAttribute('data-amb-wall-locale') || 'uk';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('wall ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var active = Number(data && data.active) || 0;
        var goal = Number(data && data.goal) || 100;
        var names = (data && Array.isArray(data.names) ? data.names : []).filter(Boolean);
        if (active < 1) return; // the invitation stays

        var counter = section.querySelector('[data-amb-wall-counter]');
        var activeEl = section.querySelector('[data-amb-wall-active]');
        var goalEl = section.querySelector('[data-amb-wall-goal]');
        var label = section.querySelector('[data-amb-wall-label]');
        var bar = section.querySelector('[data-amb-wall-bar]');
        var template = section.getAttribute('data-amb-wall-count') || '';

        goalEl.textContent = String(goal);
        label.textContent = template.replace('__COUNT__', String(active)).replace('__GOAL__', String(goal));
        counter.hidden = false;
        section.querySelector('[data-amb-wall-empty]').hidden = true;

        if (names.length) renderNames(section.querySelector('[data-amb-wall-names]'), names);

        whenVisible(counter, function () {
          countUp(activeEl, active, locale);
          bar.style.width = Math.min(100, Math.round((active / goal) * 100)) + '%';
        });
      })
      .catch(function () { /* the invitation stays */ });
  }

  function init() {
    document.querySelectorAll('[data-amb-wall]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
